import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center text-xl" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "fw-bolder whitespace-pre-line" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_ConfirmHoanThanh = _resolveComponent("ConfirmHoanThanh")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_Can = _resolveComponent("Can")!
  const _component_DetailTopicLottie = _resolveComponent("DetailTopicLottie")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_ResponsiveLayout = _resolveComponent("ResponsiveLayout")!
  const _component_BaseLink = _resolveComponent("BaseLink")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!
  const _component_DinhMucCoDinhSection = _resolveComponent("DinhMucCoDinhSection")!
  const _component_BienBanGiaiTheTable = _resolveComponent("BienBanGiaiTheTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationDialog, {
      title: "Xác nhận",
      size: "sm",
      "is-display": _ctx.isConfirmDeleteDialogDisplay,
      onOnConfirmButtonClick: _ctx.confirmDelete,
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isConfirmDeleteDialogDisplay = false)),
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isConfirmDeleteDialogDisplay = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("h4", _hoisted_1, [
          _createTextVNode(" Bạn có chắc chắn muốn xóa biên bản giải thể "),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.selectedBienBanForDelete?.so_bien_ban), 1),
          _createTextVNode("? ")
        ])
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _createVNode(_component_ConfirmHoanThanh, {
      "bien-ban-data": _ctx.selectingBienBan,
      show: _ctx.confirmHoanThanhBienBan,
      onConfirm: _ctx.hoanThanhHander,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmHoanThanhBienBan = false))
    }, null, 8, ["bien-ban-data", "show", "onConfirm"]),
    _createVNode(_component_PageContentBase, { plain: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_PageContentSection, null, {
          header: _withCtx(() => [
            _createTextVNode(" Chi tiết ")
          ]),
          actions: _withCtx(() => [
            _createVNode(_component_Can, {
              all: [_ctx.KE_HOACH_SUA_CHUA.SUA]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ButtonCustom, {
                  "button-type": _ctx.ButtonsType.EDIT,
                  classes: `rounded-none m-0`,
                  "color-type": _ctx.ButtonTypeColors.SUCCESS,
                  "tooltip-message": "Chỉnh sửa kế hoạch",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.push(`/quan-ly/ke-hoach-sua-chua/chinh-sua/${_ctx.idKeHoach}`)))
                }, null, 8, ["button-type", "color-type"])
              ]),
              _: 1
            }, 8, ["all"]),
            _createVNode(_component_Can, {
              all: [_ctx.KE_HOACH_SUA_CHUA.XOA]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ButtonCustom, {
                  "button-type": _ctx.ButtonsType.TRASH,
                  classes: `rounded-none m-0`,
                  "color-type": _ctx.ButtonTypeColors.DANGER,
                  "tooltip-message": "Xoá kế hoạch",
                  onClick: _ctx.onDeleteKeHoachButtonClick
                }, null, 8, ["button-type", "color-type", "onClick"])
              ]),
              _: 1
            }, 8, ["all"]),
            _createVNode(_component_Can, {
              all: [_ctx.BIEN_BAN_GIAI_THE.TAO_MOI]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ButtonCustom, {
                  classes: `rounded-none m-0`,
                  "button-type": _ctx.ButtonsType.ADD,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (
              _ctx.push(
                `/quan-ly/ke-hoach-sua-chua/${_ctx.idKeHoach}/bien-ban-giai-the/tao-moi`
              )
            ))
                }, {
                  "button-label": _withCtx(() => [
                    _createTextVNode("Tạo BBGT")
                  ]),
                  _: 1
                }, 8, ["button-type"])
              ]),
              _: 1
            }, 8, ["all"])
          ]),
          illustration: _withCtx(() => [
            _createVNode(_component_DetailTopicLottie, { topic: "ke-hoach-sua-chua" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("ID:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.keHoachDetail?.id), 1)
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ngày tạo:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.moment(_ctx.keHoachDetail?.created_at).format('DD/MM/YYYY')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cấp SC:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_BaseLink, {
                  to: {
              name: 'chi-tiet-cap-sua-chua',
              params: { id: _ctx.keHoachDetail?.cap_sua_chua.id },
            }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.keHoachDetail?.cap_sua_chua.ten_cap_sc), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Nhóm toa xe:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                (_ctx.keHoachDetail)
                  ? (_openBlock(), _createBlock(_component_BaseLink, {
                      key: 0,
                      to: {
              name: 'chi-tiet-danh-muc-toa-xe',
              params: { id: _ctx.keHoachDetail.danh_muc_toa_xe.id },
            }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.keHoachDetail?.danh_muc_toa_xe.ten_danh_muc), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Số lượng toa:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.keHoachDetail?.so_luong_toa_xe) + " toa", 1)
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Tháng:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.keHoachDetail?.thang), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Định mức cố định:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                (_ctx.dinhMucCoDinhhDetail)
                  ? (_openBlock(), _createBlock(_component_BaseLink, {
                      key: 0,
                      to: {
              name: 'chi-tiet-dinh-muc-co-dinh',
              params: {
                id: _ctx.dinhMucCoDinhhDetail.id,
              }
            }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.dinhMucCoDinhhDetail.danh_muc_toa_xe.ten_danh_muc) + " (" + _toDisplayString(_ctx.dinhMucCoDinhhDetail.cap_sua_chua.ten_cap_sc) + ") ", 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (_openBlock(), _createBlock(_component_LabelCustom, {
                      key: 1,
                      "is-text-muted": ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Không có biên bản tương ứng")
                      ]),
                      _: 1
                    }))
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Số văn bản:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.keHoachDetail?.so_van_ban), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, {
              "align-items": "align-items-start",
              "has-two-columns": ""
            }, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-text-muted": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ghi chú:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.keHoachDetail?.ghi_chu?.trim() || "-"), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.keHoachDetail)
          ? (_openBlock(), _createBlock(_component_DinhMucCoDinhSection, {
              key: 0,
              "button-tooltip-message": "Tạo phiếu xuất",
              idCapSuaChua: _ctx.keHoachDetail.id_cap_sc,
              idDanhMucToaXe: _ctx.keHoachDetail.id_danh_muc_toa_xe,
              "show-create-phieu-xuat-button": false,
              "status-filter": "valid"
            }, null, 8, ["idCapSuaChua", "idDanhMucToaXe"]))
          : _createCommentVNode("", true),
        _createVNode(_component_PageContentSection, null, {
          header: _withCtx(() => [
            _createTextVNode(" Biên bản giải thể ")
          ]),
          actions: _withCtx(() => [
            _createVNode(_component_ButtonCustom, {
              classes: `rounded-none m-0`,
              "button-type": _ctx.ButtonsType.ADD,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (
            _ctx.push(
              `/quan-ly/ke-hoach-sua-chua/${_ctx.idKeHoach}/bien-ban-giai-the/tao-moi`
            )
          ))
            }, {
              "button-label": _withCtx(() => [
                _createTextVNode("Tạo BBGT")
              ]),
              _: 1
            }, 8, ["button-type"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_BienBanGiaiTheTable, {
              "cur-page": _ctx.currentPage,
              "per-page": _ctx.perPage,
              "is-ke-hoach-column-displaying": false,
              items: _ctx.bienBanItems,
              "show-delete-button": true,
              "on-success": _ctx.safeRefetchBienBan,
              onOnDetailClick: _cache[6] || (_cache[6] = 
          ({ id }) => _ctx.push(`/quan-ly/bien-ban-giai-the/chi-tiet/${id}`)
        ),
              onOnEditClick: _cache[7] || (_cache[7] = 
          ({ id }) => _ctx.push(`/quan-ly/bien-ban-giai-the/cap-nhat/${id}`)
        ),
              onOnCheckClick: _ctx.selectBienBanHandler,
              onOnDeleteClick: _ctx.onDeleteHandler
            }, null, 8, ["cur-page", "per-page", "items", "on-success", "onOnCheckClick", "onOnDeleteClick"]),
            (_ctx.bienBanItems.length > 0)
              ? (_openBlock(), _createBlock(_component_Pagination, {
                  key: 0,
                  page: _ctx.currentPage,
                  "page-size": _ctx.perPage,
                  total: _ctx.totalItems,
                  onChangePage: _cache[8] || (_cache[8] = (value) => (_ctx.currentPage = value)),
                  onChangePageSize: _cache[9] || (_cache[9] = (value) => (_ctx.perPage = value))
                }, null, 8, ["page", "page-size", "total"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}